import { config } from '@/config'
import { buildPimlicoProxyUrl } from '@/modules/api/wefa-api'
import { createPimlicoClient } from 'permissionless/clients/pimlico'
import { http, type Chain, createPublicClient } from 'viem'
import { entryPoint07Address } from 'viem/account-abstraction'
import { base, baseSepolia, mainnet, sepolia } from 'viem/chains'

export function getChain(chainId = config.chainId): Chain {
  switch (chainId) {
    case 1:
      return mainnet
    case 8453:
      return base
    case 11155111:
      return sepolia
    case 84532:
      return baseSepolia
    default:
      return baseSepolia
  }
}

export function buildPimlicoRpcUrl(): string {
  // Route through our server proxy to keep the API key off the client
  return buildPimlicoProxyUrl()
}

export function createPimlicoClients(chainId = config.chainId) {
  const chain = getChain(chainId)
  const proxyUrl = buildPimlicoRpcUrl()

  const pimlicoClient = createPimlicoClient({
    transport: http(proxyUrl),
    chain,
    entryPoint: {
      address: entryPoint07Address,
      version: '0.7',
    },
  })

  return {
    chain,
    publicClient: createPublicClient({ chain, transport: http(chain.rpcUrls.default.http[0]) }),
    pimlicoClient,
    bundlerUrl: proxyUrl,
    sponsorshipPolicyId: config.pimlico.sponsorshipPolicyId,
  }
}

export function hasPimlicoConfigured(): boolean {
  return true
}
